/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterJ = createReactComponent("letter-j", "IconLetterJ", [
  ["path", { d: "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4", key: "svg-0" }]
]);

export { IconLetterJ as default };
//# sourceMappingURL=IconLetterJ.js.map
